export default __webpack_public_path__ + "static/media/home_portfolios_kittyGarelly.9b78bf30.jpg";